export default __webpack_public_path__ + "static/media/cl.89f44f81.svg";